@if (isValidOdds) {
    <div class="linear-container__total-odds" [ngClass]="oddsChangeIndicator">
        <span
            [ngClass]="{ 'linear-container__total-odds--boosted': boostedOdds }"
            [@oldOddsAnimation]="boostedOdds ? formattedOdds(totalOdds) : null"
            >{{ formattedOdds(totalOdds) }}</span
        >
        @if (boostedOdds) {
            <span class="linear-container__boosted-odds" [@newOddsAnimation]="formattedOdds(boostedOdds)">{{ formattedOdds(boostedOdds) }}</span>
        }
    </div>
} @else {
    <div class="linear-container-total-odds__zero-value">
        <span class="linear-container-total-odds__dash">-</span>
        <span class="linear-container-total-odds__dash">-</span>
    </div>
}
